export const RCM_ASSIGNMENT_LANDING = 'RCM_ASSIGNMENT_LANDING';
export const RCM_ASSIGNMENT_LANDING_PENDING = 'RCM_ASSIGNMENT_LANDING_PENDING';
export const RCM_ASSIGNMENT_LANDING_FULFILLED = 'RCM_ASSIGNMENT_LANDING_FULFILLED';
export const RCM_ASSIGNMENT_LANDING_REJECTED = 'RCM_ASSIGNMENT_LANDING_REJECTED';


export const RCM_ASSIGNMENT_CHANGE_PRECEDENCE="RCM_ASSIGNMENT_CHANGE_PRECEDENCE"
export const RCM_ASSIGNMENT_CHANGE_PRECEDENCE_PENDING="RCM_ASSIGNMENT_CHANGE_PRECEDENCE_PENDING"
export const RCM_ASSIGNMENT_CHANGE_PRECEDENCE_FULFILLED="RCM_ASSIGNMENT_CHANGE_PRECEDENCE_FULFILLED"
export const RCM_ASSIGNMENT_CHANGE_PRECEDENCE_REJECTED="RCM_ASSIGNMENT_CHANGE_PRECEDENCE_REJECTED"

export const RCM_ASSIGNMENT_CREATE_UPDATE_DIALOG="RCM_ASSIGNMENT_CREATE_UPDATE_DIALOG"
export const RCM_ASSIGNMENT_DELETE_DIALOG="RCM_ASSIGNMENT_DELETE_DIALOG"


export const rcmAssignmentLanding = () => ({
    type: RCM_ASSIGNMENT_LANDING
});

export const changePrecedence = (options, callback) => ({
    type: RCM_ASSIGNMENT_CHANGE_PRECEDENCE,
    payload: { options, callback }
});

export const rcmAssignmentCreateUpdateDialog = (options) => ({
    type: RCM_ASSIGNMENT_CREATE_UPDATE_DIALOG,
    payload:{...options}
});

export const rcmAssignmentDeleteDialog = (options) => ({
    type: RCM_ASSIGNMENT_DELETE_DIALOG,
    payload:{...options}
});